@if (canDisplayPage) {
  @if (canCallApiDashboard) {
    <dashboard [queryParams]="httpParams"></dashboard>
  } @else {
    <forbidden [forbiddenType]="forbiddenType" [contract]="contract" [isSosh]="isSosh$ | async"></forbidden>
  }
} @else {
  <div class="py-5" data-e2e="spinner">
    <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
  </div>
}
